<template>
  <div class="flex flex-col items-center py-8" data-testid="request-contents-upselling">
    <h1 class="mb-3 font-bold text-center text-3xl text-zinc-900 dark:text-zinc-100">Request Video</h1>

    <p class="max-w-xl mb-10 text-xl text-center text-zinc-700 dark:text-zinc-300 px-2">Easily Request and Collect Videos — No Downloads Needed</p>

    <iframe
      src="https://share.zight.com/01953e74-5a54-7bdc-a9d2-d56d7b5724e6?embed=true"
      allowtransparency="true"
      allowfullscreen
      style="border: medium none"
      data-frame-src="https://share.zight.com/01953e74-5a54-7bdc-a9d2-d56d7b5724e6?embed=true"
      frameborder="0"
      class="w-full sm:rounded-lg aspect-video sm:w-144"
    />

    <div class="flex flex-col items-center gap-2 mt-10">
      <Button data-testid="request-access-button" type="solid" variant="blue" :disabled="isAccessRequested" @click="handleRequestAccess">
        {{ isAccessRequested ? 'Access Requested' : 'Request access' }}
      </Button>
      <Button
        data-testid="learn-more-button"
        type="link"
        variant="black"
        icon="general.lightBulb"
        class="mt-2"
        target="_blank"
        href="https://zight.com/request-video"
      >
        Learn more
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { Button } from '@/storybook';
import { useToast } from '@/composables/useToast';
import { useTrack } from '@/composables/useTrack';
import { useUserStore } from '@/store/useUserStore';
import { useOrganizationStore } from '@/store/useOrganizationStore';

const { success } = useToast();
const { track } = useTrack();
const userStore = useUserStore();
const organizationStore = useOrganizationStore();
const { id: userId, email } = storeToRefs(userStore);
const { id: orgId, ownerId, planCode } = storeToRefs(organizationStore);

const isAccessRequested = ref(false);

const handleRequestAccess = () => {
  if (isAccessRequested.value) {
    return;
  }

  // Track the feature access request (matches backend pattern)
  track('feature_access_request', {
    feature_name: 'request-video',
    user_id: userId.value,
    email: email.value,
    org_id: orgId.value,
    owner_id: ownerId.value,
    plan: planCode.value,
  });

  isAccessRequested.value = true;
  success("Request sent successfully. We'll get back to you soon.");
};
</script>
